import { render } from "./Branches_Managment_Dialog.vue?vue&type=template&id=0f359ab8&scoped=true&ts=true"
import script from "./Branches_Managment_Dialog.vue?vue&type=script&lang=ts"
export * from "./Branches_Managment_Dialog.vue?vue&type=script&lang=ts"

import "./Branches_Managment_Dialog.vue?vue&type=style&index=0&id=0f359ab8&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f359ab8"]])

export default __exports__